import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
    Router,
    RouterLink,
    RouterLinkActive,
    RouterModule,
    RouterOutlet,
} from '@angular/router';
import { HeaderComponent } from '../header/header.component';

import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule, DOCUMENT, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AjudaComponent } from '../components/ajuda/ajuda.component';
import { MatDialog } from '@angular/material/dialog';
import { UtilSharedDataService } from '../service/UtilSharedDataService';
import { environment } from '../../environments/environments';
@Component({
    selector: 'app-ciberark',
    standalone: true,
    imports: [
    ],
    templateUrl: './ciberark.component.html',
})
export class CiberarkComponent{
private redirectUriCiberark = environment.redirectUriCiberark;
  constructor()
 {
    window.location.href = this.redirectUriCiberark;
 }
}
